import { atom } from "recoil";

export const isEngAtom = atom({
  //lang setting
  key: "isEng",
  default: false,
});
